export const selectIsBrowserSecurityWarningSilenced = (state: IState) =>
  state.userSettings.isBrowserSecurityWarningSilenced
